<template>
  <div class="outputs-editor">
    <div v-for="v in video" :key="v.id" class="video-output">
      <div class="preview">
        <img v-if="thumbnailUrl" :src="thumbnailUrl">
        <template v-else>
          <video v-if="source.type==='video'">
            <source :src="url">
          </video>
          <img v-if="source.type==='image'" :src="url">
          <iframe v-if="source.type==='html'" :src="url"></iframe>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { PxAWOutputVideo, PxAWSource, PxResolution, pxVideoOutputOrientation } from '@pxflux/px-notation'

export default {
  name: 'OutputsEditor',
  components: {},
  props: {
    value: { type: Object, required: true },
    source: { type: PxAWSource, required: true }
  },

  data: () => ({}),

  mounted () {
    this.resetVideoOutput()
  },

  watch: {
    source () {
      this.resetVideoOutput()
    }
  },

  computed: {
    outputs: {
      get () { return this.value },
      set (newValue) { this.$emit('input', newValue) }
    },
    video: {
      get () { return this.outputs.video.length ? this.outputs.video : [] },
      set (video) {
        this.outputs = { ...this.outputs, video }
      }
    },
    audio: {
      get () { return this.outputs.audio },
      set (audio) { this.outputs = { ...this.outputs, audio } }
    },

    url () {
      /** @type {PxAWSource} source */
      const source = this.source
      if (!source || !source.url) return null
      if (source.files.length) {
        const index = source.files.find(f => f.path || f.name === source.url)
        if (!index) return null
        if (index.file) {
          return URL.createObjectURL(index.file)
        } else {
          return index.url
        }
      } else {
        return source.url
      }
    },

    thumbnailUrl () {
      const source = this.source
      if (source.thumbnail && (source.thumbnail.url || source.thumbnail.file)) {
        return source.thumbnail.url || URL.createObjectURL(source.thumbnail.file)
      }
      return ''
    }
  },

  methods: {
    resetVideoOutput () {
      this.video = [this.defaultVideoOutputForSource(this.source)]
    },
    /**
     * @param {PxAWSource} source
     * @return {PxAWOutputVideo}
     */
    defaultVideoOutputForSource (source) {
      const o = PxAWOutputVideo.preset()
      if (source.resolution) {
        o.resolution = PxResolution.from(source.resolution)
        o.orientation = source.resolution.w >= source.resolution.h
          ? pxVideoOutputOrientation.Landscape
          : pxVideoOutputOrientation.Portrait
      }
      return o
    }
  }
}
</script>

<style lang="scss">
  .outputs-editor {
    .video-output {
      iframe {
      }
    }

    .preview {
      position: relative;
      width: 200px;
      height: 112px;
      background: #000;

      & > * {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
</style>
